import axios from 'axios';

// In dev: empty string so the CRA proxy handles /api -> localhost:8082
// In production: set REACT_APP_API_URL to your backend's base URL (e.g. https://api.yourdomain.com)
const BASE_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: `${BASE_URL}/api`,
});

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Normalize error messages from backend
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const message =
      error.response?.data?.error ||
      error.response?.data?.message ||
      error.message ||
      'Something went wrong';
    error.userMessage = message;
    return Promise.reject(error);
  }
);

export interface LoginResponse {
  token: string;
  user: {
    id: string;
    name: string;
    email: string;
    role: string;
  };
}

export interface SignupResponse extends LoginResponse {}

export const authService = {
  async login(email: string, password: string): Promise<LoginResponse> {
    const response = await api.post('/auth/login', { email, password });
    return response.data;
  },

  async signup(name: string, email: string, password: string): Promise<SignupResponse> {
    const response = await api.post('/auth/signup', { name, email, password });
    return response.data;
  },
};

export default api;
